import { render, staticRenderFns } from "./OrgHeader.vue?vue&type=template&id=5d56a71e&scoped=true&lang=pug"
import script from "./OrgHeader.vue?vue&type=script&lang=js"
export * from "./OrgHeader.vue?vue&type=script&lang=js"
import style0 from "./OrgHeader.vue?vue&type=style&index=0&id=5d56a71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d56a71e",
  null
  
)

export default component.exports